export function getIsServerRendered() {
  return typeof window === 'undefined';
}

export function isDevelopmentMode() {
  return process.env.NODE_ENV === 'development' && !getIsServerRendered();
}

export function enableAxe() {
  import('react').then(({ default: React }) => {
    import('react-dom').then(({ default: ReactDOM }) => {
      import('@axe-core/react').then(({ default: axe }) => {
          axe(React, ReactDOM, 1000)
      });
    });
  });
}
